import { FC } from 'react';

import TableBody from 'modules/_shared/Table/components/TableBody';

import { useNotifyPartnersDividendsModal } from '../context/NotifyPartnersDividendsModalContext';
import PartnersTableViewRow from './PartnersTableViewRow';

const PartnersTableViewBody: FC = () => {
  const { data } = useNotifyPartnersDividendsModal();

  const hasData = data.partnersData && data.partnersData.length > 0;

  const rows = data.partnersData?.map((partner, index) => (
    <PartnersTableViewRow
      // eslint-disable-next-line react/no-array-index-key
      key={`partner-row-${index}`}
      index={index}
      partner={partner}
    />
  ));

  return <TableBody hasData={hasData} content={rows} noDataMessage="" />;
};

export default PartnersTableViewBody;
